module.exports = __webpack_public_path__ + "img/rule_title.11d61a76.png";